<template>
 <div>
  <label for = "objeto-select" class="form-label">Motivo de Dispensa de Multa:</label>
  <MultiSelect
   v-model = "selectedObjeto"
   :options = "objeto"
   mode = "single"
   :searchable = "true"
   :close-on-select="true"
   valueProp = "valor"
   trackBy = "texto"
   label = "texto"
   placeHolder = "Selecione um Motivo de Dispensa de Multa"
   id="item-select"
  />
 </div>
</template>

 <script lang = "ts">
  import { defineComponent, ref, onMounted, watch } from "vue";
  import servico from "@/services/biblioteca/bibmotivodispensamulta/bibmotivodispensamulta.service";
  import TextoValor from "@/models/texto-valor";

  export default defineComponent({
   name: "DropDownListComponente",
   props: {
    modelValue: {
     type: Number,
     default: null,
    },
   },
   emits:["update:modelValue"],
   setup(props, { emit }) {
    const objeto = ref < TextoValor[]>([]);
    const selectedObjeto = ref < Number | null>(props.modelValue); 
    const loading = ref(false);
    const fetchObjeto = async() => {
     loading.value = true;
     try {
      const result = await servico.DropDownList();
      objeto.value = result.map((item) => ({
       valor: item.valor,
       texto: item.texto,
      }));
      if (!objeto.value.some((item) => item.valor === props.modelValue)) { 
       selectedObjeto.value = null;
      }
     } catch (err) {
      console.error("Erro ao carregar Motivo de Dispensa de Multa:", err);
     } finally {
      loading.value = false;
     }
    };
    
    watch(
     () => props.modelValue,
     (newValue) => {
      selectedObjeto.value = newValue;
     },
     {immediate: true }
    );
    
    watch(selectedObjeto, (newValue) => {
     emit("update:modelValue", newValue);
    });
    
    onMounted(fetchObjeto);
     return {
     objeto,
     selectedObjeto,
     loading,
    };
   },
  });
 </script>
